module.exports = __webpack_public_path__ + "img/bussiness.0ef90f0e.png";